module.exports = __webpack_public_path__ + "static/media/DC_O_Embroidery_Accademia_White_3955_3377_3364.10f33fd8.png";